import { FC, memo } from 'react';
import { useAppDispatch, useResponsive } from '../../../../hooks';
import { setMobileAppModalOpen } from '../../request-single-page-slice';
import { detectStore, useMobileAppLink } from '../../utils';
import {
  Wrapper,
  TextContainer,
  LinkText,
  ErrorCircle,
  ErrorsIcon,
  ButtonsWrapper,
} from './error.styled';
import { Text, Button, HStack, VStack } from '../../components-v4';
import { ReactComponent as MaxIcon } from '../../assets/max-icon.svg';
import { ReactComponent as TelegramIcon } from '../../assets/Telegram-icon.svg';

export const Error: FC = memo(() => {
  const { viewport } = useResponsive();
  const dispatch = useAppDispatch();
  const store = detectStore();
  const link = useMobileAppLink(store);

  const handleDownloadApp = () => {
    if (!viewport.desktop) {
      window.open(link, '_blank', 'noopener noreferrer');

      return;
    }

    dispatch(setMobileAppModalOpen(true));
  };

  const handleOpenTelegramBot = () => {
    const link = document.createElement('a');
    link.href = 'https://t.me/arseniy_kabinet_bot/';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.click();
  };

  const handleOpenMaxBot = () => {
    const link = document.createElement('a');
    link.href = 'https://max.ru/id7806206017_bot';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.click();
  };

  return (
    <Wrapper isMobile={viewport.mobile}>
      <ErrorCircle isMobile={viewport.mobile}>
        <ErrorsIcon isMobile={viewport.mobile} />
      </ErrorCircle>
      <TextContainer>
        <Text
          variant={viewport.mobile ? 'heading-3' : 'heading-2'}
          color="gray.800"
        >
          Ссылка недействительна
        </Text>
        <Text
          variant={viewport.mobile ? 'body-14' : 'body-16'}
          color="gray.500"
          style={{ textAlign: 'center' }}
        >
          Возможно, срок действия ссылки истёк, или она содержит ошибку.
        </Text>
        <Text
          variant={viewport.mobile ? 'body-14' : 'body-16'}
          color="gray.500"
          style={{ textAlign: 'center' }}
        >
          Установите и зарегистрируйтесь в{' '}
          <LinkText
            href={'https://кабинет-жителя.рф'}
            target={'_blank'}
            rel="noopener noreferrer"
          >
            личном кабинете-жителя.рф
          </LinkText>{' '}
          для удобства отслеживания заявок, оплаты счетов и передачи показаний.
        </Text>
        <Text
          variant={viewport.mobile ? 'body-14' : 'body-16'}
          color="gray.500"
          style={{ textAlign: 'center' }}
        >
          Запустите{' '}
          <LinkText
            href={'https://t.me/arseniy_kabinet_bot/'}
            target={'_blank'}
            rel="noopener noreferrer"
          >
            Telegram-бота
          </LinkText>{' '}
          — он напомнит о сроках сдачи показаний, сообщит о новых счетах и
          важных новостях.
        </Text>
      </TextContainer>
      <ButtonsWrapper isMobile={viewport.mobile} isDesktop={viewport.desktop}>
        <VStack
          spacing="xs"
          style={{
            maxWidth: viewport.desktop ? 'fit-content' : '600px',
            width: '100%',
          }}
        >
          <Button
            size={viewport.desktop ? 'm' : 'l'}
            mode="accent"
            variant="main"
            onClick={handleDownloadApp}
            style={{ width: '100%' }}
          >
            Скачать мобильное приложение
          </Button>
          <HStack spacing="xs">
            <Button
              size={viewport.desktop ? 'm' : 'l'}
              mode="additional"
              variant="main"
              onClick={handleOpenMaxBot}
              leftIcon={<MaxIcon />}
              style={{
                flex: viewport.desktop ? '0 1 auto' : '1',
              }}
            >
              Бот в MAX
            </Button>
            <Button
              size={viewport.desktop ? 'm' : 'l'}
              mode="additional"
              variant="main"
              onClick={handleOpenTelegramBot}
              leftIcon={<TelegramIcon />}
              style={{
                flex: viewport.desktop ? '0 1 auto' : '1',
              }}
            >
              Бот в Telegram
            </Button>
          </HStack>
        </VStack>
      </ButtonsWrapper>
    </Wrapper>
  );
});
